export default function (userInputs, labels, store, adultPrice, childPrice) {

    const basket = []
    const isFighter = userInputs.find((item) => item.name === 'isFighter')
    const donationAmount = userInputs.find(
        (item) => item.name === 'donationAmount'
    )
    const donationPerLightBag = userInputs.find(
        (item) => item.name === 'donationPerLightBag'
    )
    const deltagere = userInputs.find((item) => item.name === 'deltagere')
    const childDeltagere = userInputs.find(
        (item) => item.name === 'childDeltagere'
    )

    const isChild = userInputs.find((item) => item.name === 'isChild')

    basket.push({
        label: labels.yourInformationTotalYourDeltagergebyrLabel,
        amount: '',
        price: `${isChild.value ? childPrice : adultPrice} kr.`,
        intPrice: isChild.value ? childPrice : adultPrice
    })

    if (isFighter && isFighter.value) {
        basket.push({
            label: labels.yourInformationTotalFighterLabel,
            amount: '',
            price: '0 kr.',
            intPrice: 0
        })
    }

    if (
        donationAmount &&
        donationAmount.value &&
        donationPerLightBag &&
        donationPerLightBag.value
    ) {
        basket.push({
            label: labels.yourInformationTotalTaendteLysLabel,
            amount: `${donationAmount.value} ${labels.taendEtLysUnitLabel} (á ${donationPerLightBag.value} kr.)`,
            price: `${donationAmount.value * donationPerLightBag.value} kr.`,
            intPrice: donationAmount.value * donationPerLightBag.value
        })
    }

    if (deltagere && deltagere.value.length > 0) {
        basket.push({
            label: labels.yourInformationTotalNewAdultDeltagereLabel,
            amount: `${deltagere.value.length} ${labels.yourInformationTotalDeltagereLabel} (á ${adultPrice} kr.)`,
            price: `${deltagere.value.length * adultPrice} kr.`,
            intPrice: deltagere.value.length * adultPrice
        })
    }

    if (childDeltagere && childDeltagere.value.length > 0) {
        basket.push({
            label: labels.yourInformationTotalNewChildDeltagereLabel,
            amount: `${childDeltagere.value.length} ${labels.yourInformationTotalDeltagereLabel} (á ${childPrice} kr.)`,
            price: `${childDeltagere.value.length * childPrice} kr.`,
            intPrice: childDeltagere.value.length * childPrice
        })
    }

    store.dispatch('stafet/basket', { basket: basket })
}
